// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createActionsHook,
	type Action,
} from '@atlassian/react-sweet-state';

type ModalOpenState = { isOpen: boolean };

const openActions = {
	setOpen:
		(isOpen: boolean): Action<ModalOpenState> =>
		({ setState }) => {
			setState({ isOpen });
		},
} as const;

const openStore = createStore<ModalOpenState, typeof openActions>({
	name: 'IssueViewModalOpenState',
	initialState: { isOpen: false },
	actions: openActions,
});

export const useIsIssueViewModalOpen = createHook<
	ModalOpenState,
	typeof openActions,
	boolean,
	undefined
>(openStore, { selector: (state) => state.isOpen });

export const useIssueViewModalOpenActions = createActionsHook(openStore);

type ModalReadyState = { isReady: boolean };

const readyActions = {
	setReady:
		(isReady: boolean): Action<ModalReadyState> =>
		({ setState }) => {
			setState({ isReady });
		},
} as const;

const readyStore = createStore<ModalReadyState, typeof readyActions>({
	name: 'IssueViewModalReadyState',
	initialState: { isReady: false },
	actions: readyActions,
});

export const useIsIssueViewModalReady = createHook<
	ModalReadyState,
	typeof readyActions,
	boolean,
	undefined
>(readyStore, { selector: (state) => state.isReady });

export const useIssueViewModalReadyActions = createActionsHook(readyStore);
